<template>
  <div class="gd-lad-view__right-part">
    <form @submit.prevent>
      <h3 class="gd-text-center">Résumé</h3>
      <div class="gd-label big">
        <label for="nameForConf">Nom pour la nouvelle configuration :</label>
        <input
          id="nameForConf"
          ref="inputRef"
          type="text"
          class="gd-input-text"
          required
          v-model="name"
          autocomplete="nom de la configuration">
      </div>
      <div class="gd-label big">Métadonnées associées au fichier :</div>
      <ul v-if="test.length > 0" class="gd-lad-view__list">
        <li v-for="meta in test" :key="meta.metadata.tagName" class="gd-lad-view__list-item">
          {{meta.metadata.friendlyName}}
          <button
            class="gd-rounded-btn gd-rounded-btn__ladright"
            @click="deleteMeta(meta)">
            <IconClose class="gd-rounded-btn__icon"></IconClose>
          </button>
          <button class="gd-rounded-btn gd-rounded-btn__ladright" @click="updateMetadata(meta)">
            <IconUpdate class="gd-rounded-btn__icon"></IconUpdate>
          </button>
        </li>
      </ul>
      <div class="gd-text-center">
        <button v-if="metadatas.length > 0"
                v-on:click="saveMetadatas" class="gd-default-btn">
          {{ this.saveOnEdocFactory }}
        </button>
        <div v-else>Aucune métadonnée enregistrée</div>
      </div>
    </form>
  </div>
</template>

<script>
import IconClose from '@/assets/svg/icon-close.svg';
import IconUpdate from '@/assets/svg/icon-update.svg';

export default {
  name: 'lad-right',
  components: {
    IconClose,
    IconUpdate,
  },
  data() {
    return {
      test: this.metadatas,
      name: '',
      saveOnEdocFactory: 'J\'ai fini ! Enregistrer',
    };
  },
  props: {
    configurationName: String,
    metadatas: Array,
  },
  methods: {
    updateMetadata(meta) {
      this.$parent.updateMetadata(meta.metadata.tagName);
    },
    deleteMeta(meta) {
      this.$parent.deleteMeta(meta);
    },
    saveMetadatas() {
      if (document.getElementById('nameForConf').checkValidity()) {
        this.$parent.saveMetadatas(this.name);
      } else {
        this.$store.dispatch('app/openSnackbar', {
          message: 'Veuillez entrer un nom pour cette nouvelle configuration',
        });
      }
    },
  },
  mounted() {
    this.name = this.configurationName;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LADRight.vue